import React, {useState} from 'react';
import {ContactErrors} from '../../../util/interfaces';
import {showDialog, showSnackbar, validateEmail} from '@dvrd/dvr-controls';
import ContactPage from "./contactPage";
import {sendContactRequest} from "../../../util/requestSender";
import {ResponseData} from '@dvrd/fetch';
import {createErrorMessage} from "../../../util/utils";
import {useNavigate} from 'react-router';
import {REGISTER_ROUTE} from "../../../util/constants";

const emptyErrors: ContactErrors = {name: null, email: null, message: null};

export default function ContactController() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [errors, setErrors] = useState<ContactErrors>(emptyErrors);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    function onClickRegister() {
        navigate(REGISTER_ROUTE);
    }

    function onChangeName(value: string) {
        setName(value);
        onResetError('name')();
    }

    function onChangeEmail(value: string) {
        setEmail(value);
        onResetError('email')();
    }

    function onChangeMessage(value: string) {
        setMessage(value);
        onResetError('message')();
    }

    function onResetError(key: keyof ContactErrors) {
        return function() {
            setErrors({...errors, [key]: null});
        }
    }

    function onSubmit() {
        if (!validateValues()) return;
        setLoading(true);
        sendContactRequest({
            data: {name, email, message}, callback: (data: ResponseData) => {
                setLoading(false);
                if (data.success) {
                    showSnackbar('We hebben uw contactverzoek ontvangen');
                    setName('');
                    setEmail('');
                    setMessage('');
                    setErrors(emptyErrors);
                } else
                    showDialog(
                        createErrorMessage(data.message ?? 'Het verzenden van uw contactverzoek is niet gelukt.'),
                        'Verzending mislukt');
            }
        })
    }

    function validateValues(): boolean {
        const _errors = {...errors};
        let valid: boolean = true;
        if (!name) {
            valid = false;
            _errors.name = 'Vul je naam in';
        }
        if (!email) {
            valid = false;
            _errors.email = 'Vul je e-mailadres in';
        } else if (!validateEmail(email)) {
            valid = false;
            _errors.email = 'Vul een geldig e-mailadres in';
        }
        if (!message) {
            valid = false;
            _errors.message = 'Vul je bericht in';
        }
        if (!valid) setErrors(_errors);
        return valid;
    }

    return (
        <ContactPage onChangeName={onChangeName} onChangeEmail={onChangeEmail} onChangeMessage={onChangeMessage}
                     onResetError={onResetError} onSubmit={onSubmit} onClickRegister={onClickRegister} name={name}
                     email={email} message={message} errors={errors} loading={loading}/>
    );
}